module.exports = __webpack_public_path__ + "img/avatar2.bf981613.png";